import { Link } from "react-router-dom";
import { LegalLayout } from "@/components/legal/LegalLayout";
import { LegalP, LegalSection, LegalUl } from "@/components/legal/LegalProse";
import { CONTACT, OPERATOR, PAYMENTS } from "@/lib/legal";
import { tw } from "@/lib/theme";

export function PaymentsPage() {
  return (
    <LegalLayout
      title="Payments"
      subtitle="Direct INR purchases for creator support, subscriptions, and content unlocks."
    >
      <LegalSection title="Overview">
        <LegalP>
          {OPERATOR.product} uses <strong>{PAYMENTS.provider}</strong> in India for direct INR
          checkout (UPI, cards, and netbanking). We do <strong>not</strong> sell virtual currency,
          wallet credits, or resellable tokens. Each payment is for a specific digital product or
          service at the time of purchase.
        </LegalP>
        <LegalP>
          <strong>Sparks</strong> are in-app reward points for creators—not cash—and are separate
          from paid checkout.
        </LegalP>
      </LegalSection>

      <LegalSection title="What you can pay for">
        <LegalUl
          items={[
            "Creator tips — optional one-time support via UPI or card.",
            "Creator subscriptions — monthly access to supporter-only posts (shown in INR before you pay).",
            "Content unlocks — one-time payment to access a specific paid drop or collectible post.",
            "Promoted posts — optional ad campaigns for creators (separate checkout).",
          ]}
        />
      </LegalSection>

      <LegalSection title="Creator payouts">
        <LegalP>
          When a creator has completed Cashfree vendor onboarding, a portion of eligible tips,
          subscriptions, and unlocks may be transferred to their linked bank account per our creator
          terms. Until onboarding is complete, funds may settle to the platform account for later
          disbursement.
        </LegalP>
      </LegalSection>

      <LegalSection title="Purchases">
        <LegalUl
          items={[
            "Prices are shown in INR before you confirm payment.",
            "Access (subscription or unlock) is granted after Cashfree confirms success.",
            "Failed or abandoned checkouts are not charged.",
            "Receipts are sent by Cashfree and/or email where configured.",
          ]}
        />
      </LegalSection>

      <LegalSection title="Refunds and cancellation">
        <LegalP>
          Refund eligibility, subscription cancellation, and dispute handling are described in our{" "}
          <Link to="/RefundandCancellation" className={tw.link}>
            Refund and Cancellation Policy
          </Link>
          .
        </LegalP>
      </LegalSection>

      <LegalSection title="Taxes">
        <LegalP>
          You are responsible for any taxes on creator earnings. We may collect tax information
          where required for payouts.
        </LegalP>
      </LegalSection>

      <LegalSection title="Contact">
        <LegalP>
          Payment disputes:{" "}
          <a href={`mailto:${CONTACT.support}`} className={tw.link}>
            {CONTACT.support}
          </a>
          . Include your registered email and Cashfree order/payment reference. See also{" "}
          <Link to="/TermsandConditions" className={tw.link}>
            Terms and Conditions
          </Link>
          .
        </LegalP>
      </LegalSection>
    </LegalLayout>
  );
}
